import React from 'react';
import { Popup, Tooltip } from 'react-leaflet';
import VehicleMarker from './VehicleMarker';
import LicensePlateTag from 'src/app/components/licensePlateTag/LicesePlateTag';
import ContentCarInfo from 'src/app/components/popupInfocar/ContentCarInfo';
import { Box } from '@material-ui/core';
import { formatDisplayName } from 'src/app/utils/vehicleDisplay';

const POPUP_OFFSET = [0, -35];
const TOOLTIP_OFFSET = [0, -35];

const PADDING_PERCENT_LEFT = 0.45;
const PADDING_PERCENT_TOP = 0.25;
const PADDING_PERCENT_RIGHT = 0.45;
const PADDING_PERCENT_BOTTOM = 0.4;

const MarkerManager = ({
  vehicle,
  position,
  isSelected,
  isInViewport,
  onClick,
  markerRef,
  vehicleIconsRef,
  positionsInfoBox,
  detailedVehicleInfo,
  isLoadingDetail,
  opacity = 1,
  popupAutoPan = true
}) => {
  const [padding, setPadding] = React.useState({
    topLeft: [
      window.innerWidth * PADDING_PERCENT_LEFT,
      window.innerHeight * PADDING_PERCENT_TOP
    ],
    bottomRight: [
      window.innerWidth * PADDING_PERCENT_RIGHT,
      window.innerHeight * PADDING_PERCENT_BOTTOM
    ]
  });
  const fullText =
    vehicle?.is_display_name && vehicle?.name
      ? vehicle.name
      : vehicle?.license_plate || '';
  const displayText =
    vehicle?.is_display_name && vehicle?.name
      ? formatDisplayName(vehicle.name, 20)
      : vehicle?.license_plate || '';
  const hasEllipsis =
    typeof displayText === 'string' && displayText.endsWith('...');

  React.useEffect(() => {
    const updatePadding = () => {
      setPadding({
        topLeft: [
          window.innerWidth * PADDING_PERCENT_LEFT,
          window.innerHeight * PADDING_PERCENT_TOP
        ],
        bottomRight: [
          window.innerWidth * PADDING_PERCENT_RIGHT,
          window.innerHeight * PADDING_PERCENT_BOTTOM
        ]
      });
    };
    window.addEventListener('resize', updatePadding);
    return () => window.removeEventListener('resize', updatePadding);
  }, []);

  if (!vehicle || vehicle.debt) return null;

  return (
    <VehicleMarker
      vehicle={vehicle}
      position={position}
      isSelected={isSelected}
      isInViewport={isInViewport}
      onClick={onClick}
      markerRef={markerRef}
      vehicleIconsRef={vehicleIconsRef}
      opacity={opacity}
    >
      {!vehicle.debt && (
        <Popup
          offset={POPUP_OFFSET}
          autoPanPaddingTopLeft={padding.topLeft}
          autoPanPaddingBottomRight={padding.bottomRight}
          autoPan={popupAutoPan}
          maxWidth={650}
          minWidth={300}
          maxHeight={500}
        >
          <ContentCarInfo
            positionsInfoBox={positionsInfoBox}
            detailedVehicleInfo={detailedVehicleInfo}
            isLoadingDetail={isLoadingDetail}
          />
        </Popup>
      )}

      {(isInViewport || isSelected) && opacity > 0 && (
        <Tooltip
          direction="center"
          offset={TOOLTIP_OFFSET}
          permanent
          opacity={1}
          className='vehicle-label'
        >
          <Box
            style={{ marginTop: '0px' }}
            title={hasEllipsis ? fullText : ''}
          >
            <LicensePlateTag
              isSelected={isSelected}
              position={vehicle}
              license_plate={displayText}
              color={isSelected ? 'white' : '#000000'}
              backgroundColor={isSelected ? '#D9042F' : '#F5FAFF'}
            />
          </Box>
        </Tooltip>
      )}
    </VehicleMarker>
  );
};

export default React.memo(MarkerManager);
